import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Button } from '../components/ui/button';
import { Mail, Phone, MapPin } from 'lucide-react';

const Wholesale = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      mirror: false,
    });
  }, []);
  return (
    <div className="min-h-screen">

      {/* Hero Section */}
      <section className="relative h-[60vh] min-h-[400px] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              'url(/images/coffee-farmer.jpg)',
            filter: 'brightness(0.6)',
          }}
        />
        <div className="relative z-10 text-center text-white px-4" data-aos="fade-up">
          <h1 className="text-4xl md:text-7xl font-bold mb-6">Wholesale</h1>
          <p className="text-xl md:text-2xl max-w-2xl mx-auto">
            Premium Indonesian coffee for your business. Quality beans,
            competitive prices, reliable service.
          </p>
        </div>
      </section>

      {/* Wholesale Detail Section (Like Image) */}
      <section className="py-20" style={{ backgroundColor: '#31415A' }}>

        <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-14 items-center">

            {/* Left Content */}
            <div data-aos="fade-right">
              <h2
                className="text-3xl md:text-5xl font-bold mb-6"
                style={{ color: '#FFFFFF' }}
              >
                Iraga Roastery
              </h2>

              <p className="text-lg text-white mb-4">
                Great Coffee Starts with the Right Beans
              </p>

              <p className="text-white mb-4">
                We partner with businesses that take coffee seriously.
                Our wholesale coffee program delivers freshly roasted,
                high-quality coffee beans sourced from trusted farms and
                roasted to highlight their true character.
              </p>

              <p className="text-white mb-6">
                Whether you run a café, restaurant, hotel, or office,
                we provide consistent quality, reliable supply, and
                coffee your customers will remember.
              </p>

              <ul className="list-disc pl-5 space-y-2 text-white mb-8">
                <li>Fresh coffee beans roasted regularly</li>
                <li>Consistent flavor your customers can trust</li>
                <li>Wholesale pricing that grows with your business</li>
                <li>Easy ordering and dependable delivery</li>
              </ul>

              <p className="text-white mb-10">
                Serve coffee that reflects your brand’s standards — from
                the first sip to the last. Let’s build a long-term coffee
                partnership.
              </p>

              <div className="flex flex-wrap gap-4">
                <Button
                  size="lg"
                  className="px-10 rounded-full font-semibold"
                  style={{ backgroundColor: '#FFFFFF', color: '#31415A' }}
                  onClick={() => window.location.href = `mailto:${window.APP_CONFIG?.email || 'iragacoffee@gmail.com'}?subject=Wholesale Inquiry`}
                >
                  Email us
                </Button>

                <Button
                  size="lg"
                  className="px-10 rounded-full font-semibold"
                  style={{ backgroundColor: '#FFFFFF', color: '#31415A' }}
                  onClick={() => {
                    const waNumber = (window.APP_CONFIG?.wa || '628113888969').replace('+', '');
                    window.open(`https://wa.me/${waNumber}?text=Hello, I am interested in wholesale coffee from Iraga Coffee Roastery.`, '_blank');
                  }}
                >
                  WhatsApp
                </Button>
              </div>
            </div>

            {/* Right Image */}
            <div className="w-full h-full" data-aos="fade-left">
              <img
                src="/images/-30.jpg"
                alt="Coffee roasting"
                className="w-full h-full object-cover rounded-lg shadow-lg"
              />
            </div>

          </div>
        </div>
      </section>

    </div>
  );
};

export default Wholesale;
